import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Insurer } from '../models/insurer';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class InsurerService {

    constructor(private http: HttpClient) { }

    getAll(): Observable<Insurer[]> {
        return this.http.get(environment.apiHost + '/secure/insurers/').pipe(map((response: any) => response.data.insurers as Insurer[]));
    }
}
